<template>
  <b-dropdown aria-role="list" @change="handleItemChange">
    <button class="button" slot="trigger">
      <span>{{displayedValue}}</span>
    </button>

    <b-dropdown-item v-for="mapping in mappings"
                     aria-role="listitem"
                     :value="mapping.value"
                     :key="mapping.value"
    >{{mapping.label}}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>


  import BDropdown from "buefy/src/components/dropdown/Dropdown";
  import BDropdownItem from "buefy/src/components/dropdown/DropdownItem";

  export default {
    components: {
      BDropdownItem,
      BDropdown
    },
    name: "control-dropdown",
    props: ['propValue', 'textMappings', 'disabled', 'onChange', 'suffix'],
    data() {
      return {
        value: 0,
        mappings: []
      };
    },
    watch: {
      textMappings(value) {
        this.parseMappings({textMappings: value});
      },
      propValue(value) {
        this.value = value;
      }
    },
    computed: {
      displayedValue() {
        return this.suffix ? `${this.value} ${this.suffix}` : this.value;
      }
    },
    methods: {
      parseMappings(opt) {
        const textMappings = typeof opt !== "undefined" && typeof opt['textMappings'] !== "undefined" ? opt["textMappings"] : this.textMappings;
        if (textMappings) {
          const splits = textMappings.split(/;/);
          splits.forEach(item => {
            const secSplits = item.split(/=/);
            if (typeof secSplits[1] !== "undefined") {
              this.mappings.push({
                label: secSplits[0],
                value: secSplits[1]
              });
            }
          });
        }
      },
      handleItemChange(newValue) {
        this.value = newValue.toString();
        if (typeof this.onChange === "function") {
          this.onChange(this.value);
        }
      }
    },
    mounted() {
      this.parseMappings();
      if (this.propValue) {
        this.value = this.propValue;
      }
    }
  }
</script>

<style scoped>

</style>